import { useTranslation } from "react-i18next";
import {
  EmptyWrapper,
  MesageListWrapper,
  MessageDropdownWrapper,
  MessageItem,
  MessageLink,
  MoreText,
} from "./atom";
import { Link } from "task-eva-ui";
import RightIcon from "./icon/right-icon";
import EmptyIcon from "./icon/empty-icon";
import { dateFormatter } from "project-config/utils/date-formatter";
import { isDev } from "project-config/utils/env";

export function MessageDropdown({
  fiveMessageList,
  isZh,
  isDomestic,
}: {
  fiveMessageList: any[];
  isZh: boolean;
  isDomestic: boolean;
}) {
  const { t } = useTranslation("common");
  const baseUrl = isDev() ? "https://task-pre" : "https://task";
  const host = isDomestic ? ".renderbus.com" : ".foxrenderfarm.com";
  return (
    <MessageDropdownWrapper>
      <MessageLink>
        <span>{t("message_center")}</span>
        <Link href={`${baseUrl}${host}/message/jobConfig`} target="_blank">
          {t("message_receiving_settings")}
        </Link>
      </MessageLink>
      <MesageListWrapper>
        {fiveMessageList && fiveMessageList.length > 0 ? (
          fiveMessageList.map((item: any, index) => (
            <MessageItem key={index} isRead={item.isRead}>
              <div>{isZh ? item.message : item.messageExtend}</div>
              <div className="create-time">
                {dateFormatter(item.createTime)}
              </div>
            </MessageItem>
          ))
        ) : (
          <EmptyWrapper>
            <EmptyIcon />
            <p>{t("message_empty")}</p>
          </EmptyWrapper>
        )}
      </MesageListWrapper>
      <MoreText>
        <Link href={`${baseUrl}${host}/message/center`} target="_blank">
          {t("message_see_more")}
          <RightIcon />
        </Link>
      </MoreText>
    </MessageDropdownWrapper>
  );
}
